import { Component } from '@angular/core';
import { UndeliveredReasonsListComponent } from '../../../../components/admin-dashboard-component/undelivered-reasons-component/undelivered-reasons-list-component/undelivered-reasons-list-component';

@Component({
  selector: 'app-undelivered-reasons-list-page',
  standalone: true,
  imports: [UndeliveredReasonsListComponent],
  templateUrl: './undelivered-reasons-list.html',
  styleUrl: './undelivered-reasons-list.scss',
})
export class UndeliveredReasonsList {}